import { Link } from "react-router-dom";
import BaseLayout from "../../layouts/BaseLayout/BaseLayout";
import GridLayout from "../../layouts/GridLayout/GridLayout";

const tools = [1, 2, 3, 4, 5, 6];

const Tools = () => {
  return (
    <BaseLayout>
      <GridLayout>
        <h2 className="col-span-full text-xl font-semibold my-6">Available Tools</h2>
          {tools.map((toolNum) => (
            <Link
              to={`/tools/${toolNum}`}
              key={toolNum}
              className="col-span-4 h-fit px-8 py-6 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <h3 className="text-lg font-medium">Tool {toolNum}</h3>
            </Link>
          ))}
      </GridLayout>
    </BaseLayout>
  );
};

export default Tools;